import api from '../api/index'
import router from '../../router'

const state = {
  race: {}
}

const mutations = {
  setRace: function(state, payload) {
    state.race = payload
  }
}

const actions = {
  loadRace: function (context, raceId) {
    api.getRace(raceId, function (data) {
      console.log(data)
      context.commit('setRace', data)
      context.dispatch('loadRaceAthletes', {raceId: raceId, update: false})
      context.dispatch('loadRaceCheckpoints', raceId)
      context.dispatch('loadRaceRoute', raceId)
      context.dispatch('loadRaceRouteProfile', raceId)
      context.dispatch('loadFavourites', raceId)
      context.dispatch('setIntervalAsync', raceId)
      document.title = data.name + ' - ' + 'Sportraxs'
      // context.dispatch('loadProfile', raceid)
      // document.title = data.races[0].name
      // let inRaces = false
      // for (var i = 0; i < data.races.length; i++) {
      //   if (data.races[i].id === racekeys[1]) {
      //     inRaces = true
      //   }
      // }
      // let raceId
      // if (typeof (racekeys[1]) !== 'undefined' && inRaces) {
      //   raceId = racekeys[1]
      // } else if (typeof (racekeys[1]) !== 'undefined' && !inRaces) {
      //   raceId = data.races[0].id
      // } else {
      //   raceId = data.races[0].id
      // }

      // context.dispatch('focusRace', raceId)
    })
  }
}

const getters = {
  race: state => {
    return state.race
  },
  races: state => {
    return state.races
  },
  raceId: state => {
    return state.race.id
  },
  raceDist: state => {
    return 50000
  },
  raceType: state => {
    return state.race.tracking_type
  },
  raceShowPositions: state => {
    return state.race.tracking_positions
  },
  focusedRace: state => {
    return state.focusedRace
  },
  eid: state => {
    return state.eid
  },
  staggeredStart: state => {
    let staggeredStart = false
    // return staggeredStart ? parseInt(state.focusedRace.staggered_start) === 1 : (state.focusedRace.staggered_start === null || parseInt(state.focusedRace.staggered_start) === 0)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/race.js